module.exports = __webpack_public_path__ + "static/media/calender-512.068deede.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Welcome/calender-512.png
// module id = 539
// module chunks = 0